import { Locale } from "@/services/global-services/models";
import { create } from "zustand";

type PageEditorStore = {
    regions: Locale[];
    activeRegion: string;
    setRegions: (regions: Locale[]) => void;
    setActiveRegion: (region: string) => void;

    fullscreen: boolean;
    setFullscreen: (fullscreen: boolean) => void;
};

const usePageEditorStore = create<PageEditorStore>()((set) => ({
    regions: [],
    activeRegion: "",
    setRegions: (regions: Locale[]) => set({ regions }),
    setActiveRegion: (region: string) => set({ activeRegion: region }),

    fullscreen: false,
    setFullscreen: (fullscreen: boolean) => set({ fullscreen }),
}));

export default usePageEditorStore;
